/** Мероприятие */
export default {
  create: 'Создание',
  createProgramme: 'Создание программы с помощью ИИ',
  aiProgramme: 'программа ИИ',
  name: 'Название мероприятия',
  placeholder: 'Введите название мероприятия',
  total: 'Всего регистраций',
  likes: 'Общее количество лайков',
  income: 'Общий доход от регистраций',
  tips: {
    total: 'Количество заявителей не включает отмены',
    income: 'Доход не включает возвраты, награды и продажи продуктов'
  },
  table: {
    name: 'Название мероприятия',
    status: 'Статус мероприятия',
    total: 'Всего регистраций',
    today: 'Регистрации за сегодня',
    last_week: 'Регистрации за прошлую неделю',
    create: 'Время создания',
    update: 'Время обновления',
    start: 'Время начала',
    end: 'Время окончания',
    operate: 'Операция',
    oper: {
      data: 'Данные регистрации',
      config: 'Настройка контента',
      progress: 'Настройка прогресса',
      display: 'Отображение мероприятия',
      screen: 'Экран данных',
      share: 'Поделиться мероприятием',
      more: 'Дополнительные функции',
      mores: {
        setting: 'Настройки отображения',
        ad: 'Настройки рекламы',
        live: 'Прямая трансляция изображений',
        video: 'Видео-хайлайты',
        qrcode: 'QR-код для регистрации',
        gift: 'Подарки и призы'
      }
    },
    total_number: 'Всего {total} элементов'
  },
  create_form: {
    placeholder: 'Пожалуйста, введите',
    status: {
      '是否确认立刻发布活动?': 'Вы уверены, что хотите опубликовать мероприятие немедленно?'
    },
    content: {
      title: 'Содержание мероприятия',
      name: {
        label: 'Название мероприятия',
        hover: 'Название этого мероприятия, например: первая детская выставка живописи'
      },
      cycle: {
        label: 'Цикл мероприятия',
        hover: 'Общее время мероприятия, от начала до конца: Например: 20.01.2024 ~ 20.05.2024; если не определено, пожалуйста, укажите предполагаемый период'
      },
      stage: {
        title: 'Этап мероприятия',
        desc: 'Сейчас можно создать только один этап. Для добавления дополнительных завершите начальную настройку, затем используйте "Расширенная конфигурация" в списке мероприятий.',
        name: {
          title: 'Название этапа',
          hover: 'Название этапа мероприятия. В настоящее время можно установить только один этап; например: первый тур или второй тур или прослушивание или финал'
        },
        start: {
          title: 'Время регистрации',
          hover: 'Время начала и окончания регистрации для этого этапа, пожалуйста, укажите с точностью до минуты и секунды. Примечание: Регистрация не разрешена вне периода регистрации; если не определено, можно заполнить позже'
        },
        hold: {
          title: 'Время проведения',
          hover: 'Время начала и окончания этого этапа, пожалуйста, укажите с точностью до минуты и секунды, например: период офлайн-выставки или период церемонии награждения; если не определено, можно заполнить позже'
        }
      },
      poster: {
        title: 'Постер мероприятия',
        upload: 'Нажмите для загрузки',
        tips: {
          _1: 'Подсказка: Поддерживаются форматы изображений .jpg, .png; максимальный размер изображения не может превышать 5MB; соотношение размеров изображения должно быть по возможности 1:1, минимальный размер 860px*860px',
          _2: 'Изображение будет отображаться в верхней части страницы заявителя, нажмите для просмотра легенды'
        }
      },
      detail: {
        desc: 'Видно для регистрантов, нажмите для просмотра легенды',
        placeholder: 'Пожалуйста, введите',
        title: {
          _1: 'Введение в мероприятие',
          _2: 'Правила регистрации',
          _3: 'Организация'
        }
      }
    },
    group: {
      title: 'Информация о группе',
      desc: 'В настоящее время можно создать только одно групповое мероприятие. Есть несколько разных групповых мероприятий. Пожалуйста, сначала завершите начальное создание мероприятия, а затем нажмите "Конфигурация мероприятия - Конфигурация под-соревнования" мероприятия в списке мероприятий для настройки. Система мероприятий поддерживает, что разные групповые мероприятия могут устанавливать разные регистрационные сборы, регистрационные формы, базовый отбор, регистрационные формы и другие настройки',
      category: {
        title: 'Мероприятие',
        hover: 'Пример: Искусство; Танец;',
        add: 'Добавить категорию',
        name: 'Название категории'
      },
      group: {
        title: 'Группа мероприятия',
        hover: 'Пример: Молодежная группа; Взрослая группа;',
        add: 'Добавить группу',
        name: 'Название группы'
      },
      form: {
        title: 'Регистрационная форма',
        hover: 'Информационное содержание, которое должен заполнить регистрант; разные категории или группы могут использовать разные регистрационные формы',
        create: 'Создать информацию о регистрации на мероприятие'
      },
      charge: {
        title: 'Регистрационный сбор',
        hover: 'Для разных категорий или групп можно установить разные сборы'
      },
      config: {
        title: 'Подробные настройки конфигурации:',
        hover: 'Для разных категорий или групп можно установить разные правила отбора, критерии отбора, методы отбора, количество отборов, время объявления результатов отбора и т.д.',
        repeat: {
          title: 'Повторная регистрация для одной группы:',
          hover: 'Разрешает ли групповое мероприятие пользователям регистрироваться несколько раз с одной и той же информацией',
          default: 'Закрыть'
        },
        pass: {
          title: 'Проверка регистрации:',
          hover: 'После отправки пользователем регистрации, будет ли система по умолчанию проверять её для определения валидности/невалидности регистрации',
          default: 'Автоматически пройдено',
          prepay: 'Сначала проверка, потом оплата',
          postpay: 'Сначала оплата, потом проверка'
        },
        show: {
          title: 'Отображение в центре регистрации:',
          hover: 'Индивидуальный: регистрация при заполнении информации об одном человеке; "Команда": регистрация, состоящая из информации нескольких человек, разделяющих одну работу',
          default: 'Отображать'
        },
        form: {
          title: 'Групповая регистрационная форма:',
          hover: 'Индивидуальный: регистрация при заполнении информации об одном человеке; "Команда": регистрация, состоящая из информации нескольких человек, разделяющих одну работу',
          default: 'Индивидуальный',
          team: 'Команда',
          min: 'Минимальный размер команды:',
          max: 'Максимальный размер команды:'
        },
        base: {
          title: 'Базовая функция оценки:',
          hover: 'Включить ли базовую функцию оценки; пример: Включить или Закрыть',
          default: 'Закрыть'
        },
        commission: {
          title: 'Комиссия партнера:',
          hover: 'Как подчиненный канал организатора, партнер устанавливает процент комиссии от регистрационного сбора',
          default: 'Закрыть'
        },
        inherit: {
          title: 'Наследование номера отбора:',
          hover: 'В расширенном управлении отбором в главном меню можно установить номер отбора для зарегистрированных работ, и номер может быть унаследован в следующий раунд при продвижении',
          default: 'Закрыть'
        }
      }
    },
    session: {
      title: 'Информация о сессии',
      desc: 'Подсказка: Текущее создание сессии связано только с групповым мероприятием, созданным на предыдущем шаге. Несколько групповых мероприятий имеют расписание сессий. Пожалуйста, сначала завершите начальное создание мероприятия, войдите в управление мероприятием и нажмите "Конфигурация мероприятия - Конфигурация под-соревнования - Конфигурация сессии" для настройки. Одна группа может создать несколько сессий, и разные группы также могут создавать разные сессии.',
      name: 'Групповые мероприятия',
      number: {
        title: 'Регистранты',
        hover: 'Регистранты устанавливаются для одной сессии. Если есть несколько сессий, количество участников для каждой сессии нужно устанавливать отдельно',
        config: 'Настройки',
        default: 'Без ограничений'
      },
      arrange: {
        title: 'Расписание сессий',
        hover: 'Если соответствующие расписания сессий еще не определены, можно закрыть; если расписания сессий уже есть, можно открыть для настройки, поддерживаются онлайн и офлайн',
        default: 'Закрыть'
      },
      form: 'Формат сессии:',
      online: 'Онлайн-адрес',
      offline: 'Выбор региона',
      address: 'Подробный адрес',
      time: 'Время сессии'
    }
  }
}



// WEBPACK FOOTER //
// ./src/langs/ru/activity.js